export const ErrorsNotToLog = [
    "Your session is not up to date, please refresh your browser and try again",
    "A new version of JST has been released, please refresh your browser",
    "AADSTS50058: A silent sign-in request was sent but no user is signed in", // There has to be a better way than this
];
